import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig"

const API_URL = `${API_BASE_URL}/api/PatientInfo/assignments`;

export const getPatientAssignments = async ({ page, pageSize, locationId, memberType }) => {
  try {
    const params = {
      page,
      pageSize,
      locationId,
      memberType,
    };

    const response = await axios.get(API_URL, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      params,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching patient assignments:", error);
    throw error;
  }
};
